/**
 * SeverityBadge — color-coded pill used across calculator result panels.
 *
 * Levels: low → bl-green · moderate → bl-warn · high → bl-rust · critical → bl-rust (darker).
 * The component is purely deterministic; no AI, no images, no external data.
 */
const STYLES = {
    low: "bg-[var(--bl-green)] text-white",
    moderate: "bg-[var(--bl-warn)] text-white",
    high: "bg-[var(--bl-rust)] text-white",
    critical: "bg-[var(--bl-rust)] text-white ring-2 ring-[var(--bl-rust)]/40",
};

export default function SeverityBadge({ severity, size = "sm" }) {
    if (!severity) return null;
    const cls = STYLES[severity.level] || STYLES.low;
    const sizeCls = size === "lg"
        ? "px-4 py-1.5 text-sm tracking-wide"
        : "px-2.5 py-0.5 text-xs tracking-wide";
    return (
        <span
            className={`inline-flex items-center rounded-full font-semibold uppercase ${cls} ${sizeCls}`}
            data-testid={`severity-badge-${severity.level}`}
            aria-label={`Severity ${severity.label}`}
        >
            {severity.label || severity.level}
        </span>
    );
}
